$(function () {
    $('.uptime-table-content').each(function (index, el) {
        $.ajax({
            url: Routing.generate('get_uptime'),
            type: 'json',
            method: 'GET',
            success: function (response) {
                $(el).html(response);
                $('.uptime-table').show();
            }
        });
    });
});

